import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { PagePopup } from '~/components/ui/PagePopup';
import { useDate } from '~/libs/hooks/useDate';
import { useLocationState } from '~/libs/hooks/useLocationState';

import { ReportListPhotoModel } from '../../libs/types';
import { getProcessText } from '../ReportListFilter/ReportListFilter.helper';

import { ReportPhotosDetail } from './ReportPhotos.Detail';

export interface ReportPhotosItemProps {
  data: ReportListPhotoModel;
}

export const ReportPhotosItem = (props: ReportPhotosItemProps) => {
  const { data } = props;
  const { t } = useTranslation('report');
  const [visible, setVisible] = useLocationState(false);
  const navigate = useNavigate();
  const { formatDate } = useDate();

  return (
    <ItemWrap
      className={data.height && data.width ? 'ratio-mode' : ''}
      style={{
        paddingBottom: (data.height / data.width) * 100 + '%',
      }}
    >
      <LazyLoadImage
        src={data.thumbnailUrl || data.url}
        width="100%"
        height="100%"
        effect="opacity"
        onClick={() => setVisible(true)}
      />

      <PagePopup
        visible={visible}
        title={t('report:photo_detail_title').toString()}
        position="bottom"
        onClose={() => navigate(-1)}
      >
        <ReportPhotosDetail data={data} />
      </PagePopup>

      <WorkDate>{formatDate(data.workDate)}</WorkDate>
      {!!data.process && (
        <ProcessName>{getProcessText(data?.process?.title, data?.task?.text)}</ProcessName>
      )}
    </ItemWrap>
  );
};

const ItemWrap = styled.div`
  position: relative;
  min-height: 100px;
  background-color: #d9d9d9;
  overflow: hidden;

  &.ratio-mode {
    .lazy-load-image-background {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .lazy-load-image-background.opacity {
    opacity: 0;
    transition: opacity 0.3s;
    &.lazy-load-image-loaded {
      opacity: 1;
    }
  }
`;

const WorkDate = styled.div`
  position: absolute;
  top: 4px;
  left: 8px;

  color: white;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.02em;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
`;

const ProcessName = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;

  display: flex;
  align-items: center;
  width: 100%;
  min-height: 23px;
  padding: 4px 8px;

  color: #d9d9d9;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  background: rgba(0, 0, 0, 0.3);
`;
